import React from 'react';

import Icon from '../Icon/Icon';

const CheckIconV2 = (props) => {
    return (
        <Icon width='48' height='48' viewBox='0 0 48 48' fill='none' {...props}>
            <circle cx='24' cy='24' r='18' fill='#00D1D2' />
            <path
                d='M16 25.0543L20.5244 29.7895L32 18'
                stroke='#393E44'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </Icon>
    );
};

export default CheckIconV2;
